// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.detail-summary-wrapper {
  width: fit-content;
  margin: auto;
  padding: 0em 1em;
}

div.detail-summary-wrapper h2 {
  font-size: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/detail/display/detailSummary/DetailSummary.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["div.detail-summary-wrapper {\n  width: fit-content;\n  margin: auto;\n  padding: 0em 1em;\n}\n\ndiv.detail-summary-wrapper h2 {\n  font-size: 1.5rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
